import React from 'react';
import { ORGAN_DISPLAY_NAMES, OrganEnum, OrganQualityEnum } from '../../clients/viewer';
import ToggleGroup from '../ToggleGroup';

const LABELS = { on: 'Good', off: 'Poor' };

interface QualityToggleProps {
  value?: OrganQualityEnum;
  onChange: (value?: OrganQualityEnum) => void;
  disabled?: boolean;
  organ: OrganEnum;
}

export default function QualityToggle({ value, onChange, disabled, organ }: QualityToggleProps) {
  return (
    <ToggleGroup
      value={value === undefined ? undefined : value === OrganQualityEnum.GOOD}
      onChange={next =>
        onChange(
          next === undefined
            ? undefined
            : next
              ? OrganQualityEnum.GOOD
              : OrganQualityEnum.POOR
        )
      }
      disabled={disabled}
      label={`${ORGAN_DISPLAY_NAMES[organ]} quality`}
      labels={LABELS}
    />
  );
}
